/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verified_SellerInputs */

const en_verified_seller = /** @type {(inputs: Verified_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Seller`)
};

const id_verified_seller = /** @type {(inputs: Verified_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual Terverifikasi`)
};

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const es_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const fr_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const de_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const ja_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const zh_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const ar_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const it_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const ru_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const pt_verified_seller = en_verified_seller;

/** @type {(inputs: Verified_SellerInputs) => LocalizedString} */
const ko_verified_seller = en_verified_seller;

/**
* | output |
* | --- |
* | "Verified Seller" |
*
* @param {Verified_SellerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const verified_seller = /** @type {((inputs?: Verified_SellerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verified_SellerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_verified_seller(inputs)
	if (locale === "es") return es_verified_seller(inputs)
	if (locale === "fr") return fr_verified_seller(inputs)
	if (locale === "de") return de_verified_seller(inputs)
	if (locale === "ja") return ja_verified_seller(inputs)
	if (locale === "zh") return zh_verified_seller(inputs)
	if (locale === "ar") return ar_verified_seller(inputs)
	if (locale === "id") return id_verified_seller(inputs)
	if (locale === "it") return it_verified_seller(inputs)
	if (locale === "ru") return ru_verified_seller(inputs)
	if (locale === "pt") return pt_verified_seller(inputs)
	return ko_verified_seller(inputs)
});